<template>
  <div id="app">
    <Landing v-if="storeState.view === 1" />
    
    <WebGL v-if="storeState.view === 2" />
  </div>
</template>
<!-- <Name v-if="storeState.view === 2" /> -->
<script>
import store from './store';

import Landing from './scenes/Landing'
import Name from './scenes/Name'
import WebGL from './scenes/WebGL'


export default {
  name: 'App',
  components: {
    Landing,
    Name,
    WebGL
  },
  data() {
    return {
      storeState: store.state,
      instagram: false
    }
  },
  created() {
    console.log(`
          __                       ___.                          .___
  _______/  |_  ___________ ___.__.\\_ |__   _________ _______  __| _/
 /  ___/\\   __\\/  _ \_  __ <   |  | | __ \\ /  _ \\__  \\\_  __ \\/ __ | 
 \\___ \\  |  | (  <_> )  | \\/\___  | | \\_\\ (  <_> ) __ \\|  | \\/ /_/ | 
/____  > |__|  \____/|__|   / ____| |___  /\\____(____  /__|  \____ | 
     \\/                     \\/          \\/           \\/           \\/ 
      `)

    console.log('\n\n\tsend us an email - info@storyboard.gg\n\n')
  }
}
</script>

<style>
@font-face {
    font-family: Gameness;
    font-weight: bold;
    src: url("/gameness.otf") format("opentype");
}
* {
  border: 0;
  margin: 0;
  padding: 0;
  /*font-family: Gameness;*/
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #517394;*/
  color: #F8BB3E;
  width: 100%;
  height: 100%;
}

html {
  width: 100%;
  height: 100%;
}

body {
  width: 100%;
  height: 100%;
  background-color: #000;
}
</style>
